import { render, staticRenderFns } from "./ViolationRegulation.vue?vue&type=template&id=2d46b278&scoped=true"
import script from "./ViolationRegulation.vue?vue&type=script&lang=js"
export * from "./ViolationRegulation.vue?vue&type=script&lang=js"
import style0 from "./ViolationRegulation.vue?vue&type=style&index=0&id=2d46b278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d46b278",
  null
  
)

export default component.exports